/**
 * TableHeaderRow.jsx
 *
 * @Author: apple
 * @Date: 2018/3/8 15:19
 */

import React from 'react';
import classNames from 'classnames';
import ExpandMore from '../icons/internals/ExpandMore';
import ExpandLess from '../icons/internals/ExpandLess';
import UnfoldMore from '../icons/internals/UnfoldMore';
import TableFilter from './TableFilter';
import judgeBroswer from '../util/judgeBroswer';

const sortIcons = {
  sort: UnfoldMore,
  'sort-up': ExpandLess,
  'sort-down': ExpandMore,
};
/**
 * @ignore
 * */
class TableHeaderRow extends React.PureComponent {
  getTableHeader = el => {
    const { tableHeaderRef } = this.props;
    tableHeaderRef && tableHeaderRef(el);
  };

  render() {
    const {
      theadClassName,
      renderColumns,
      handleSetSort,
      sortState,
      onClickTh,
      prefixCls,
      expandRow,
      height,
      textCenter,
    } = this.props;
    const { isIE, isIE11 } = judgeBroswer;
    return (
      <thead className={theadClassName} style={{ height }} ref={this.getTableHeader}>
        <tr onClick={() => expandRow}>
          {renderColumns.map((elm, i) => {
            const { key, title, filters, filterMultiple, filterMethod, sort } = elm;
            const style = Object.assign({}, elm.style, {
              height,
            });
            const Component = sortIcons[sortState[key]];
            return (
              <th
                key={`th-${i}`}
                style={style}
                className={classNames(
                  elm.className,
                  {
                    'text-left':
                      !textCenter && !renderColumns[i].textCenter && (isIE() || isIE11()),
                  },
                  { 'text-center': renderColumns[i].textCenter },
                )}
                onClick={event => onClickTh(event, elm, i)}>
                {title}
                {sort && (
                  <Component
                    className={`${prefixCls}-icon`}
                    data-sort={i}
                    style={{ userSelect: 'none' }}
                    onClick={() => handleSetSort(elm.key, i)}/>
                )}
                {filters && (
                  <TableFilter
                    prefixCls={prefixCls}
                    filters={filters}
                    filterMultiple={filterMultiple}
                    filterMethod={filterMethod}
                    id={i}/>
                )}
                {elm.renderHeader && elm.renderHeader('header', elm, elm.key)}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }
}

export default TableHeaderRow;



// WEBPACK FOOTER //
// ./src/table/TableHeaderRow.jsx